import { defineStore } from "pinia";
const defaultRouteParams = () => ({
    start_district: "",
    end_district: "",
    start_neighborhood: "",
    end_neighborhood: "",
    mandatory_points: [],
    max_distance_km: 20.0,
    route_count: 3,
    min_passenger_count: 0,
    max_intermediate_polygons: 5,
    use_corridor: true,
    corridor_buffer_km: 3.0,
});
const defaultClusteringParams = () => ({
    n_clusters: 500,
    random_state: 42,
    buffer_distance: 0.01,
    force_recreate: false,
});
/**
 * Rota optimizasyonu modül state (Pinia iskelet).
 * Kaynak: RouteOptimizationView.vue setup() — micro-7-9 grep.
 * View bağlantısı: micro-7-11; slim: micro-7S-2.
 */
export const useRouteStore = defineStore("route", {
    state: () => ({
        activeTab: "clustering",
        isProcessing: false,
        showParametersModal: false,
        selectedRouteIndex: null,
        expandedRouteIndex: null,
        corridorGenerated: false,
        clusteringResults: null,
        clusteringParams: defaultClusteringParams(),
        availableDistricts: [],
        districtNeighborhoods: {},
        filteredClusters: [],
        showODFlows: false,
        isDistrictDropdownOpen: false,
        isNeighborhoodDropdownOpen: false,
        selectedDistricts: [],
        selectedNeighborhoods: [],
        districtSearchText: "",
        neighborhoodSearchText: "",
        routeParams: defaultRouteParams(),
        optimizationResults: null,
        selectedMandatoryType: "district",
        selectedMandatoryValue: "",
        selectedMandatoryDistrict: "",
        selectedCorridorPolygons: [],
        corridorEditMode: false,
    }),
    getters: {
        hasResults(state) {
            return state.activeTab === "clustering"
                ? state.clusteringResults !== null
                : state.optimizationResults !== null;
        },
    },
    actions: {
        /** micro-7-11 öncesi: view local state ile senkron değil */
        reset() {
            this.activeTab = "clustering";
            this.isProcessing = false;
            this.showParametersModal = false;
            this.selectedRouteIndex = null;
            this.expandedRouteIndex = null;
            this.corridorGenerated = false;
            this.clusteringResults = null;
            this.clusteringParams = defaultClusteringParams();
            this.availableDistricts = [];
            this.districtNeighborhoods = {};
            this.filteredClusters = [];
            this.showODFlows = false;
            this.isDistrictDropdownOpen = false;
            this.isNeighborhoodDropdownOpen = false;
            this.selectedDistricts = [];
            this.selectedNeighborhoods = [];
            this.districtSearchText = "";
            this.neighborhoodSearchText = "";
            this.routeParams = defaultRouteParams();
            this.optimizationResults = null;
            this.selectedMandatoryType = "district";
            this.selectedMandatoryValue = "";
            this.selectedMandatoryDistrict = "";
            this.selectedCorridorPolygons = [];
            this.corridorEditMode = false;
        },
    },
});
